/**
 * Javni pregled projekata — GET /api/v1/projects
 * Slike se skeniraju iz foldera galerije (classpath static/gallery + opciono GALLERY_FS_PATH).
 * Opcioni meta podaci u backend: gallery/gallery-metadata.yml (overrides).
 *
 * Stavka: filename, relativePath, title, lokacija, tipMaterijala, imageUrl, caption?, sortOrder?
 */
export async function fetchProjects() {
  const apiBase = process.env.REACT_APP_API_BASE;
  const url = apiBase
    ? `${apiBase.replace(/\/$/, '')}/v1/projects`
    : '/api/v1/projects';

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Neuspešno učitavanje projekata.');
  }
  return response.json();
}

export default { fetchProjects };
